export const LEFT_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Applicant Name",
    sortable: false,
    resizable: true
  },
  {
    key: "appliedDate",
    dataKey: "appliedDate",
    title: "Applied Date",
    sortable: false,
    resizable: true
  },
  {
    key: "videosCreated",
    dataKey: "videosCreated",
    title: "Videos Created (all-time)",
    sortable: false,
    resizable: true
  },
  {
    key: "videosViews",
    dataKey: "videosViews",
    title: "Video Views (all-time)",
    sortable: false,
    resizable: true
  },
  {
    key: "earnings",
    dataKey: "earnings",
    title: "Total Earnings (all-time)",
    sortable: false,
    resizable: true
  },
  {
    key: "id",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];

export const RIGHT_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Influencer Name",
    sortable: false,
    resizable: true
  },
  {
    key: "appliedDate",
    dataKey: "appliedDate",
    title: "Approved Date",
    sortable: false,
    resizable: true
  },
  {
    key: "videosCreated",
    dataKey: "videosCreated",
    title: "Videos Created",
    sortable: false,
    resizable: true
  },
  {
    key: "videosViews",
    dataKey: "videosViews",
    title: "Video Views",
    sortable: false,
    resizable: true
  },
  {
    key: "earnings",
    dataKey: "earnings",
    title: "Total Earnings",
    sortable: false,
    resizable: true
  },
  {
    key: "chat",
    dataKey: "id",
    title: "Chat",
    sortable: false,
    resizable: true
  },
  {
    key: "id",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];
